{
    "account.email_notifications": "Notifications par e-mail",
    "account.notification.email.moderationdecisions": "Décision de modération",
    "account.notification.email.replies": "Réponses",
    "account.warnings_and_blocks": "Avertissements et blocages",
    "account_request_data.instructions": "Envoyez un courriel à [privacy@newpublic.org](mailto:privacy@newpublic.org) pour demander une copie de vos données associées à cet espace de conversation. Le traitement de votre demande peut prendre jusqu’à 30 jours.",
    "action.delete": "Supprimer",
    "action.save": "Sauvegarder ",
    "admin_mod_link.developer_tools_label": "Outils de développement",
    "admin_mod_link.moderation_dashboard_label": "Tableau de bord de modération",
    "admin_mod_link.settings_label": "Paramètres",
    "audience_input.community_guidelines_title": "Règles de la communauté",
    "audience_input_template.description": "Stimulez l’engagement en invitant le public à partager histoires, témoignages et questions.",
    "audience_input_template.label": "Contribution du public",
    "blocklist.add_term_button": "Ajouter un terme",
    "blocklist.add_terms": "Ajouter des termes - séparez plusieurs termes avec ;",
    "blocklist.delete_confirmation": "Ces termes doivent-ils vraiment être supprimés ? Vous pouvez les ajouter à nouveau plus tard.",
    "blocklist.delete_terms": "Supprimer les termes",
    "blocklist.description": "Gérer les termes qui sont contestés et qui doivent être signalés automatiquement.",
    "blocklist.edit_term": "Modifier le terme",
    "blocklist.empty_list": "La liste de blocage est vide.",
    "blocklist.help_alternative_spellings_description": "Vous pouvez décider si des orthographes alternatives sont prises en compte. Les orthographes, chiffres et caractères spéciaux suivants sont également pris en compte :",
    "blocklist.help_alternative_spellings_title": "Orthographes alternatives :",
    "blocklist.help_case_note": "Les majuscules et les minuscules sont prises en compte",
    "blocklist.help_character_replacements": "A → a  | a → A | a → @ | a → 4 | i → 1 | e → 3 | o → 0 | s → $ | s → 5 | t → 7 | b → 8 | g → 9",
    "blocklist.help_intro": "La liste de blocage vous permet de définir des termes qui sont automatiquement empêchés d’être publiés dans les messages de la communauté. Vous pouvez ajouter vous-même des termes à cette pré-modération. Ajoutez à la liste tous les termes qui ne doivent pas être publiés sans contrôle humain.",
    "blocklist.help_singular_term_description": "Vous pouvez décider si seul le terme singulier doit être pris en compte ou si les termes qui contiennent le terme saisi doivent l’être également.",
    "blocklist.help_singular_term_example": "Exemple : « personne » (terme singulier) → « personnes ». Le terme « personnes » sera également pris en compte si la case à cocher « Terme singulier » n'est pas activée pour le terme « personne ».",
    "blocklist.help_singular_term_title": "Terme singulier",
    "blocklist.include_alternative_spellings": "Inclure des orthographes alternatives",
    "blocklist.only_singular_term": "Seul le terme singulier",
    "blocklist.settings_for_term": "Paramètres pour le terme",
    "blocklist.single_term_added_success": "Le terme « {singleTerm} » a été ajouté",
    "blocklist.singular_term_tag": "Terme singulier",
    "blocklist.term_adoption_description": "Choisissez si les termes doivent être adoptés tels quels ou s'ils doivent être inclus sous forme développée.",
    "blocklist.term_already_in_list": "Ce terme figure déjà dans la liste",
    "blocklist.terms_added_success": "Les termes {termsCount} ont été ajoutés avec succès",
    "blocklist.terms_already_in_list": "Ce terme figure déjà dans la liste",
    "blocklist.title": "liste de blocage",
    "button.react_button_aria": "{count} {tLabel} ({tSelected})",
    "button.react_button_deselected": "dessélectionné",
    "channels.no_channel": "Pas de canal",
    "comment.delete_button": "Supprimer",
    "comment.updating": "Mise à jour en cours...",
    "comment_slider.community_guidelines_title": "Règles de la communauté",
    "comment_slider.its_complicated": "C’est compliqué",
    "comment_slider_template.description": "Invitez les gens à répondre à votre question en se positionnant sur une échelle de réponse.",
    "comment_slider_template.label": "Échelle de réponse",
    "community_guidelines.rule_focus_on_ideas": "Concentrez-vous sur les idées, plutôt que sur les jugements de valeur",
    "community_guidelines.rule_provide_sources": "Fournissez des sources qui étayent vos propos ",
    "community_guidelines.title": "Règles de la communauté",
    "conversation_helper.hello_everyone": "Assistant IA",
    "conversation_helper.open_admin_dashboard": "Ouvrir le tableau de bord (admin)",
    "dashboard.table.demo.users": "Fils de discussion",
    "editorial_question.lets_talk": "Participez à la conversation",
    "form.add_button": "Ajouter",
    "form.create_space_button": "Créer l’espace",
    "form.delete_button": "Supprimer",
    "form.required_label": "{label} (obligatoire)",
    "form.save_button": "Sauvegarder ",
    "list.selected_items_count": "{keyCount} éléments sélectionnés",
    "login.logging_in": "Connexion en cours...",
    "modal.close_button": "Fermer",
    "modal.info_title": "Info",
    "moderation.add_explanation_to_user": "Ajouter un message pour l'utilisateur",
    "moderation.ai_mistake_explanation": "L’intelligence artificielle (IA) nous aide à modérer les commentaires, mais elle peut parfois faire des erreurs. Si l’IA vous empêche de partager une opinion respectueuse, veuillez soumettre votre commentaire à un modérateur pour révision.",
    "moderation.ai_wrong_question": "L’IA a-t-elle fait une erreur?",
    "moderation.dash.block_user": "Bloquer l’utilisateur",
    "moderation.dash.time": "fois",
    "moderation.dash.times": "fois",
    "moderation.dash.user_must_be_warned_2_times": "Un utilisateur doit être averti 2 fois avant d’être bloqué.",
    "moderation.explanations_sent_by_email": "Les explications sont envoyées à l'utilisateur par e-mail après le rejet du commentaire",
    "moderation.info_ai_moderation_banner_text": "Pour maintenir un environnement accueillant et respectueux, cet espace utilise l’intelligence artificielle (IA) pour aider à modérer les publications. L’IA peut signaler votre publication pour une révision supplémentaire si elle ne respecte pas les [règles de la communauté]($onPress)",
    "moderation.send_for_review_button": "Envoyer à un modérateur pour révision",
    "moderation.sending": "Envoi en cours...",
    "moderation.sent_for_review_message": "Votre réponse a été envoyée au modérateur pour révision.",
    "moderation.sent_to_moderator": "Votre réponse a été envoyée au modérateur pour révision.",
    "moderation.share_details": "Partager des détails",
    "moderation.under_review": "Révision en cours",
    "moderation.what_guideline_violate": "Quelle règle de la communauté a été enfreinte? Sélectionnez toutes les options applicables.",
    "moderation.write_additional_explanation": "Explique pourquoi tu refuses le commentaire",
    "moderationdash.title": "Tableau de bord de modération",
    "most_popular.most_recent_label": "Plus récents",
    "navigation_header.back_button": "Retour",
    "perspectives.add_your_own": "Ajouter",
    "poll.result_vote": "{tLabel}: {percent}%",
    "poll.result_your_vote": "{tLabel} (votre vote): {percent}%",
    "poll.you_comment": "Vous ({comment})",
    "poll_question.question_label": "Question de sondage (optionnel)",
    "poll_question.question_placeholder": "Écrire une question de sondage",
    "poll_result.percent": "{percent}%",
    "privacy.only_visible_to_you": "🔒 Visible uniquement par toi",
    "profile.add_custom_name": "Ajouter un pseudonyme",
    "profile.consent_aria": "J’accepte les règles de la communauté, la politique de confidentialité et les conditions d’utilisation.",
    "profile.consent_text": "J’accepte les [règles de la communauté]({communityGuidelinesLink}), la [politique de confidentialité]({privacyNoticeLink}), et les [conditions d’utilisation]({termsOfServiceLink}).",
    "profile.error_name_empty": "Les pseudonyme ne peuvent pas être vide.",
    "profile.error_name_looks_real": "Les pseudonymes ne doivent pas ressembler à de vrais noms.",
    "profile.error_name_violates": "Ce pseudonyme ne respecte pas les règles de la communauté.",
    "profile.helper_text": "Choisissez un nom et une photo qui apparaissent lorsque vous publiez dans des conversations.",
    "profile_answers.discussion_history": "Historique des conversations",
    "question.actions.close_button": "Fermer",
    "question.actions.close_confirm_button": "Fermer",
    "question.actions.copy_button": "Copier le lien",
    "question.add_content_label": "Ajouter du contenu",
    "question.add_spaces_label": "Ajouter des espaces",
    "question.moderation_label": "Modération",
    "question.prompt_label": "Amorce de conversation",
    "question.prosocial_format_label": "Modèle de conversation",
    "rating.its_complicated": "C’est compliqué",
    "reaction_types.enjoyable": "J'aime",
    "reaction_types.nuanced": "Nuancé",
    "reaction_types.playful": "Taquin",
    "reaction_types.reaction_set_label": "Type de réactions",
    "reaction_types.relatable": "Je m’identifie",
    "reaction_types.why_appreciate": "Pourquoi vous aimez ça ?",
    "related_content.add_content_button": "Ajouter du contenu",
    "related_content.show_more_button": "Afficher plus",
    "related_content.story_format_label": "Type de contenu",
    "related_content.story_url_label": "URL du contenu",
    "related_conversations.add_hint": "Ajoutez jusqu’à quatre espaces.",
    "related_conversations.no_spaces_available": "Aucun espace disponible",
    "related_conversations.search_placeholder": "Rechercher",
    "representing_perspectives_template.description": "Invitez les gens ayant une perspective particulière (ex. personne retraitée) à répondre à votre question.",
    "representing_perspectives_template.description_1": "Choisissez de **trois à cinq perspectives** que vous voulez recueillir (par ex. « 🏖️ Retraité », « 📦 Nouveau résident », « 🍼 Parent qui travaille », etc.)",
    "representing_perspectives_template.description_2": "**Évitez les perspectives basées sur des données démographiques** (par ex. « urbain », « faible revenu », « femme », etc.) qui pourraient mener à des stéréotypes",
    "representing_perspectives_template.description_3": "**Évitez d’attribuer des croyances à des perspectives** (par ex. « personne ayant une attitude conservatrice », ou « partisans » et « opposants ») )",
    "representing_perspectives_template.description_4": "**Choisissez un emoji** pour chaque perspective",
    "representing_perspectives_template.placeholder": "Écrire de trois à cinq perspectives",
    "saving": "Sauvegarde en cours...",
    "search.placeholder": "Rechercher",
    "settings.additional_features_heading": "Fonctionnalités supplémentaires",
    "settings.audience_input_description": "Stimulez l’engagement en invitant le public à partager histoires, témoignages et questions.",
    "settings.audience_input_label": "Contribution du public",
    "settings.blocklist_label": "liste de blocage",
    "settings.channels_label": "Canaux",
    "settings.comment_slider_description": "Invitez les gens à répondre à votre question en se positionnant sur une échelle de réponse.",
    "settings.comment_slider_label": "Échelle de réponse",
    "settings.moderation_heading": "Modération",
    "settings.representing_perspectives_description": "Invitez les gens ayant une perspective particulière (ex. personne retraitée) à répondre à votre question.",
    "simple_ranking.newest": "Plus récents",
    "sort.ascending": "A-Z",
    "sort.descending": "Z-A",
    "sort.most_recent": "Plus récents",
    "sorting.oldest": "Plus anciens",
    "space.table.demo.responses": "Publications",
    "space.table.search": "Rechercher",
    "spaces.column_responses": "Publications",
    "spaces.column_status": "Statut",
    "spaces.filter_closed": "Fermé",
    "spaces.format_required_label": "Modèle de conversation (obligatoire)",
    "spaces.prompt_label": "Amorce de conversation",
    "spaces.prompt_placeholder": "Écrire une question ou une amorce de conversation",
    "spaces.status_closed": "Fermé",
    "spaces.still_need_help": "Besoin d’aide?",
    "spaces.tab_label": "Fils de discussion",
    "spaces.title": "Fils de discussion",
    "spaces.visit_playbook": "Consulter le PSI Playbook",
    "suspension.moderator_blocked_you": "Un modérateur t'a bloqué",
    "suspension.moderator_unblocked_you": "Un modérateur t’a débloqué",
    "suspension.moderator_unwarned_you": "Un modérateur t'a retiré l'avertissement",
    "suspension.moderator_warned_you": "Un modérateur t'a prévenu",
    "video_voting.community_average": "Moyenne communauté",
    "video_voting.discourse": "Discourse",
    "zdf_channels.add_channel_title": "Ajouter un canal",
    "zdf_channels.add_members": "Ajouter des membres",
    "zdf_channels.channel_name_label": "Nom du canal",
    "zdf_channels.default_channel_access": "Tous les utilisateurs administrateurs ont accès au canal par défaut.",
    "zdf_channels.default_channel_explanation": "Tous les utilisateurs administrateurs ont accès au canal par défaut.\n\nLes nouvelles questions qui ne sont pas affectées à un canal spécifique seront affectées au canal par défaut.\n\nIl ne peut y avoir qu'un seul canal par défaut.",
    "zdf_channels.delete_channel_title": "Supprimer le canal",
    "zdf_channels.delete_confirmation": "Faut-il vraiment supprimer ce canal ?",
    "zdf_channels.edit_channel_title": "Modifier le canal",
    "zdf_channels.image_url_label": "Aperçu de l'URL de l'image",
    "zdf_channels.member_search_field": "Champ de recherche des membres",
    "zdf_channels.members_label": "Membres",
    "zdf_channels.use_as_default": "Utiliser comme canal par défaut",
    "zdf_moddashboard.ai_explanation": "Explication de l'IA"
}
